import React, { PureComponent } from 'react'
import { Row, Col } from 'reactstrap'
import axios from 'axios'
import DropdownCard from '../../components/DropdownCardNew'
import DeleteRequestCard from '../../components/DeleteRequestCard'
import LoaderSpinner from '../Widgets/LoaderSpinner'
import Alert from '../Widgets/Alert'
import withAlertTimeout from '../../HOCs/withAlertTimeout'
import authProtection from '../../HOCs/authProtection'

class DeleteRequests extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      requests: [],
      successMessage: null,
      success: false,
      failure: false
    }

    this.renderRequests = this.renderRequests.bind(this)
    this.closeBusiness = this.closeBusiness.bind(this)
    this.deleteBusiness = this.deleteBusiness.bind(this)
    this.denyRequest = this.denyRequest.bind(this)
  }

  componentDidMount() {
    this.fetchRequests()
  }

  fetchRequests() {
    const token = sessionStorage.getItem('token')

    const headers = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : null
    this.setState({ fetchingRequests: true })
    axios
      .get('/api/proxy/v2/businesses/deleterequests', headers)
      .then(({ data }) => {
        this.setState({ requests: data, fetchingRequests: false })
      })
      .catch(err => {
        console.log(err)
        this.setState({ fetchingRequests: false })
      })
  }

  closeBusiness(id) {
    return () => {
      const token = sessionStorage.getItem('token')
      return axios
        .put(
          `/api/proxy/v2/businesses/${id}/permanentlyclose`,
          null,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(() => {
          this.removeRequestFromState(id)
          this.showSuccess('Request Approved')
        })
        .catch(err => {
          console.log(err)
          this.props.showFailure()
        })
    }
  }

  deleteBusiness(id) {
    return () => {
      const token = sessionStorage.getItem('token')
      return axios
        .delete(
          `/api/proxy/v2/flags/objects`,
          { headers: { Authorization: `Bearer ${token}` }, data: { gnObjectType: 'business', gnObjectId: id } }
        )
        .then(() => {
          this.removeRequestFromState(id)
          this.showSuccess('Request Approved')
        })
        .catch(err => {
          console.log(err)
          this.props.showFailure()
        })
    }
  }

  denyRequest(id) {
    return () => {
      const token = sessionStorage.getItem('token')

      return axios
        .delete(
          `/api/proxy/v2/businesses/${id}/deleterequest`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(() => {
          this.showSuccess('Request Denied')
          this.removeRequestFromState(id)
        })
        .catch(err => {
          console.log(err)
          this.props.showFailure()
        })
    }
  }

  removeRequest() {

  }

  renderRequests() {
    return this.state.requests.map(request => (
      <DeleteRequestCard
        title={request.business.name}
        data={request}
        finishedWithError={this.state.failure}
        onClose={this.closeBusiness(request.business.id)}
        onDelete={this.deleteBusiness(request.business.id)}
        onDeny={this.denyRequest(request.business.id)}
        key={request.business.id}
      />
    ))
  }

  removeRequestFromState(id) {
    const filteredRequests = this.state.requests.filter(request => request.business.id !== id)
    this.setState({ requests: filteredRequests })
  }

  showSuccess(message) {
    this.setState({ success: true, successMessage: message })
    this.props.showSuccess()
  }

  render() {
    return (
      <div className="animated fadeIn">
        {
          <Alert
            active={this.props.success}
            message={this.state.successMessage || 'Success'}
          />
        }
        {
          <Alert
            type="danger"
            active={this.props.failure}
            message="Something went wrong, please try again"
          />
        }
        <Row>
          <Col xs="12">
            {this.state.fetchingRequests && <LoaderSpinner />}
            {!this.state.fetchingRequests &&
              !this.state.requests.length && (
                <h3 style={{ textAlign: 'center ' }}>
                  There are no pending requests at this time
                </h3>
              )}
            {this.renderRequests()}
          </Col>
        </Row>
      </div>
    )
  }
}

export default authProtection(withAlertTimeout(DeleteRequests))



// WEBPACK FOOTER //
// ./src/views/Pages/DeleteRequests.js